export const employmentChangeTypeRoles: any = {
  TITLE: "new-role",
  ORGANIZATION: "new-join",
  ADD_ORGANIZATION: "new-add-join"
} as const

export type SortByValue = "recently_added" | "name_az" | "last_changed_at"

export type ChampionFiltersState = {
  searchText: string
  employmentChangeType: string
  seniority: string
  duration: string
  sortBy: SortByValue
  accountFilter: string[]
}

export const filtersInitialState: ChampionFiltersState = {
  searchText: "",
  employmentChangeType: "ALL",
  seniority: "ALL",
  duration: "ALL",
  sortBy: "recently_added",
  accountFilter: [] as string[]
}

export const employmentChanges = [
  { label: "All", value: "ALL" },
  { label: "Recently joined organization", value: "ORGANIZATION" },
  { label: "Recently changed role", value: "TITLE" },
  { label: "Recently added organization", value: "ADD_ORGANIZATION" }
]

export const durations = [
  { label: "All", value: "ALL" },
  { label: "Last 1 Month", value: "1 month" },
  { label: "Last 3 Months", value: "3 months" },
  { label: "Last 6 Months", value: "6 months" }
]

export const EVENTS = {
  MESSAGE_TEMPLATE_CLICKED: "people_list_message_template_clicked",
  KNOW_YOUR_PROSPECT_CLICKED: "people_list_know_your_prospect_clicked",
  REMOVE_PEOPLE_LIST_CLICKED: "people_list_delete_icon_clicked",
  REMOVE_PEOPLE_LIST_CONFIRMATION_DISPLAYED:
    "people_list_delete_confirmation_displayed",
  REMOVE_PEOPLE_LIST_CONFIRMED: "people_list_delete_confirmed",
  REMOVE_PEOPLE_LIST_CANCELLED: "people_list_delete_cancelled",
  ADD_PEOPLE_LIST_CLICKED: "people_list_add_champions_clicked"
}
